import { render, staticRenderFns } from "./order-ok.vue?vue&type=template&id=575c10f0&"
import script from "./order-ok.vue?vue&type=script&lang=js&"
export * from "./order-ok.vue?vue&type=script&lang=js&"
import style0 from "./order-ok.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports